export const ORDER_STATUS_FLOW = [
    { key: 'CREADO', label: 'CREADO', color: 'default', phase: 'Registro' },
    { key: 'VALIDADA', label: 'VALIDADA', color: 'info', phase: 'Validación' },
    { key: 'LIBERADA', label: 'LIBERADA', color: 'primary', phase: 'Planificación' },
    { key: 'EN_EJECUCION', label: 'EN EJECUCION', color: 'warning', phase: 'Operación' },
    { key: 'FINALIZADA', label: 'FINALIZADA', color: 'success', phase: 'Cierre operativo' },
    { key: 'PRE_VALORIZADA', label: 'PRE VALORIZADA', color: 'secondary', phase: 'Pre valorización' },
    { key: 'VALORIZADA', label: 'VALORIZADA', color: 'secondary', phase: 'Valorización' },
    { key: 'FACTURADA', label: 'FACTURADA', color: 'info', phase: 'Facturación' },
    { key: 'CERRADA', label: 'CERRADA', color: 'success', phase: 'Cierre administrativo' },
    { key: 'CANCELADA', label: 'CANCELADA', color: 'error', phase: 'Cancelación' },
];

// Helper functions para usar en componentes
export const getOrderStatus = (statusKey) => {
    return ORDER_STATUS_FLOW.find(s => s.key === statusKey);
};

// Versión con Map para búsqueda más rápida (opcional)
export const ORDER_STATUS_MAP = ORDER_STATUS_FLOW.reduce((acc, status) => {
    acc[status.key] = status;
    return acc;
}, {});

// Helpers específicos
export const getStatusLabel = (statusKey) => {
    const status = ORDER_STATUS_FLOW.find(s => s.key === statusKey);
    return status?.label || statusKey;
};

export const getStatusColor = (statusKey) => {
    const status = ORDER_STATUS_FLOW.find(s => s.key === statusKey);
    return status?.color || 'default';
};

export const getStatusPhase = (statusKey) => {
    const status = ORDER_STATUS_FLOW.find(s => s.key === statusKey);
    return status?.phase || '';
};